import * as React from 'react';
import { Outer, Inner, BrandImg, Spacer, SocialIconGroup, SocialIconText, SocialIconLink, SocialIconImg } from './Social.styles';
import LOGO_AU from '../Social/images/logo-latitude.svg';
import LOGO_NZ from '../Social/images/logo-gemfinance.svg';
export default (function (_ref) {
  var data = _ref.data,
      _ref$isNz = _ref.isNz,
      isNz = _ref$isNz === void 0 ? false : _ref$isNz;
  var logoUrl = isNz ? LOGO_NZ : LOGO_AU;
  var logoText = isNz ? 'Gem Finance logo' : 'Latitude logo';
  return /*#__PURE__*/React.createElement(Outer, {
    className: "lfs-footer-social"
  }, /*#__PURE__*/React.createElement(Inner, {
    className: "lfs-inner"
  }, /*#__PURE__*/React.createElement(BrandImg, {
    src: logoUrl,
    alt: logoText,
    className: "lfs-brand-image"
  }), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(SocialIconGroup, {
    className: "lfs-social-icons"
  }, /*#__PURE__*/React.createElement(SocialIconText, null, "Connect with us"), data.map(function (item, i) {
    return /*#__PURE__*/React.createElement(SocialIconLink, {
      className: "lfs-social-icon",
      key: i,
      href: item.link,
      noStyle: true,
      target: "_blank",
      trackEventData: item.trackEventData
    }, /*#__PURE__*/React.createElement(SocialIconImg, {
      src: require("./images/" + item.icon + ".svg").default,
      alt: item.title
    }));
  }))));
});